import React from 'react';
import { IssueStatus } from '@/types/model';

const IssueStatusBadge: React.FC<{ status: IssueStatus }> = ({ status }) => {
  const statusConfig = {
    OPEN: {
      label: 'Abierto',
      bg: 'bg-green-100',
      text: 'text-green-800'
    },
    IN_PROGRESS: {
      label: 'En Progreso',
      bg: 'bg-yellow-100',
      text: 'text-yellow-800'
    },
    RESOLVED: {
      label: 'Resuelto',
      bg: 'bg-blue-100',
      text: 'text-blue-800'
    },
    IGNORED: {
      label: 'Cerrado',
      bg: 'bg-gray-100',
      text: 'text-gray-800'
    }
  };

  const config = statusConfig[status];

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      {config.label}
    </span>
  );
};

export default IssueStatusBadge;
